module.exports = __webpack_public_path__ + "static/media/service_online_2.71304835.png";